import loginForm from 'root/src/shared/descriptions/postFormSubmits/loginForm'

export default {
	...loginForm,
}
